import { render, staticRenderFns } from "./my-select.vue?vue&type=template&id=f4187788&scoped=true&"
import script from "./my-select.vue?vue&type=script&lang=js&"
export * from "./my-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4187788",
  null
  
)

export default component.exports